import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import {from, map, Observable, shareReplay} from 'rxjs';

class UploadPreferencesService {
    private static readonly API_PATH = '/upload/api/v0/config/vue';

    private uploadPreferences: Observable<DisguiseDto.UploadPreferencesDto> | null = null;

    public getUploadPreferencesCached() {
        if (this.uploadPreferences == null) {
            this.uploadPreferences = from(this.getUploadPreferences()).pipe(
                map((value) => {
                    return value.data;
                }),
                shareReplay(1)
            );
        }
        return this.uploadPreferences;
    }

    private getUploadPreferences() {
        return HTTP_SERVICE_INSTANCE.getAxios().get<DisguiseDto.UploadPreferencesDto>(UploadPreferencesService.API_PATH);
    }

}

const UPLOAD_PREFERENCES_SERVICE_INSTANCE = new UploadPreferencesService();

export {UPLOAD_PREFERENCES_SERVICE_INSTANCE};
